// extracted by mini-css-extract-plugin
export var button = "_ka-0";
export var donut = "_ka-1";
export var donutFill = "_ka-3";
export var donutTrack = "_ka-2";